// extracted by mini-css-extract-plugin
export default {"Clientes":"Clientessection_Clientes__W4H5c","Circle":"Clientessection_Circle__cM9hM","Titulo":"Clientessection_Titulo__9KoIZ","Color":"Clientessection_Color__KyE9d"};